import React from "react";
import { useAuth, hasPermission } from "../../context/AuthContext";
import LabourDayBatchReview from "../../components/labour/LabourDayBatchReview";

export default function AccountsLabourSettlementPanel() {
  const { user } = useAuth();
  const canReview = hasPermission(user, "labour.batch.review");
  const canPost = hasPermission(user, "labour.batch.post");

  return (
    <LabourDayBatchReview
      canReview={canReview}
      canPost={canPost}
      showAggregate
      title=""
      description=""
    />
  );
}
